var map = {
	"./aed.png": 895,
	"./aud.png": 896,
	"./bgn.png": 897,
	"./bhd.png": 898,
	"./cad.png": 899,
	"./chf.png": 900,
	"./cnh.png": 901,
	"./cny.png": 902,
	"./czk.png": 903,
	"./dkk.png": 904,
	"./eur.png": 905,
	"./gbp.png": 906,
	"./hkd.png": 907,
	"./hrk.png": 908,
	"./huf.png": 909,
	"./idr.png": 910,
	"./ils.png": 911,
	"./inr.png": 912,
	"./jpy.png": 913,
	"./kes.png": 914,
	"./kwd.png": 915,
	"./mxn.png": 916,
	"./myr.png": 917,
	"./nok.png": 918,
	"./nzd.png": 919,
	"./omr.png": 920,
	"./php.png": 921,
	"./pln.png": 922,
	"./qar.png": 923,
	"./ron.png": 924,
	"./rub.png": 925,
	"./sar.png": 926,
	"./sek.png": 927,
	"./sgd.png": 928,
	"./thb.png": 929,
	"./try.png": 930,
	"./ugx.png": 931,
	"./usd.png": 932,
	"./zar.png": 933
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 894;